import { Container, ShowFor, Size } from "@brightagency/headstart-common";
import ChatRoundedIcon from "@mui/icons-material/ChatRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
// import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import React from "react";
import { useGlobalLinks } from "../../../services/app-state";
import { getAcfPostUrl } from "../../../utils";
import { colors } from "../../../utils/colors";
import { useSavedItems } from "../../../utils/hooks";
import { LocationLanguageButtons } from "../../molecules/LocationLanguageButtons";
import { useTemplateThemeVariations } from "../../templates/PageTemplateChooser";
import { Outer, Inner, Actions, ActionItem } from "./styled";

export const TopBar = () => {
    const [, { getGlobalLink }] = useGlobalLinks();
    const { items: savedItems } = useSavedItems();
    const { shouldUseDarkNavBar } = useTemplateThemeVariations();

    return (
        <ShowFor size={Size.large}>
            <Outer
                style={{
                    backgroundColor: shouldUseDarkNavBar ? colors.brandMid : colors.brandDark,
                }}
            >
                <Container>
                    <Inner>
                        <LocationLanguageButtons showRegion showLanguages suburbCondition={false } />
                        <Actions>
                            <ActionItem to="/">
                                <HomeRoundedIcon />
                                Home
                            </ActionItem>
                            {/* <ActionItem to={getAcfPostUrl(getGlobalLink("local_services_page"))}>
                                <SearchRoundedIcon />
                                Search services
                            </ActionItem> */}
                            <ActionItem to={getAcfPostUrl(getGlobalLink("saved_items_page"))}>
                                <StarRoundedIcon />
                                {savedItems.length === 1
                                    ? "1 saved resource"
                                    : savedItems.length > 1
                                    ? `${savedItems.length} saved resources`
                                    : "Your saved resources"}
                            </ActionItem>
                            <ActionItem to={getAcfPostUrl(getGlobalLink("feedback_page"))}>
                                <ChatRoundedIcon />
                                Feedback
                            </ActionItem>
                        </Actions>
                    </Inner>
                </Container>
            </Outer>
        </ShowFor>
    );
};
